import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    scheduleList: [],
    scheduleArr: [],
    scheduleArray: [],
    scheduleID: "",
    scheduleName: "",
    selectedSchedule: null,
    isEditing: "",

  };
  
  const mutations = {
    initializeStore(state){
      state.scheduleList = [];
      state.scheduleArr = [];
      state.scheduleArray = [];
      state.scheduleID = '';
      state.scheduleName = '';
      state.selectedSchedule = null;
      state.isEditing = false;
    },
    SET_SELECTED_SCHEDULE(state, schedule) {
      state.selectedSchedule = schedule;
      state.isEditing = true;
    },
    SCHEDULES_ARRAY(state, schedules){
      state.scheduleArray = schedules;
    },
    LIST_LOAN_SCHEDULES(state, schedules) {
      state.scheduleList = schedules;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){

      }
    },
    RESET_SEARCH_FILTERS(state){

    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
  
    fetchArmotizationSchedules({ commit,state }, formData) {
      state.scheduleArr = [];
      axios.post(`api/v1/get-armotization-schedules/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.scheduleArr.push((response.data[i].installment + " - " + response.data[i].loan_application.loan_number + " - " + response.data[i].due_date));
        }
        commit('LIST_LOAN_SCHEDULES', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedSchedule({ commit, state }, option){
      const selectedSchedule = state.scheduleList.find(schedule => (schedule.installment + " - " + schedule.loan_application.loan_number + " - " + schedule.due_date) === option);
      if (selectedSchedule) {
          state.scheduleID = selectedSchedule.armotization_schedule_id;
          state.scheduleName = `${selectedSchedule.loan_application.loan_number} - Installment ${selectedSchedule.installment} - ${selectedSchedule.due_date}`;
          state.scheduleArray = [...state.scheduleArray, selectedSchedule];
      }
      commit('SCHEDULES_ARRAY', state.scheduleArray);
        
    },
    deleteLoanSchedule({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Schedule?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Schedule!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-armotization-schedule/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Schedule removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Schedule",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Schedule has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  